import { GiveawayStatus, RaffleV2 } from 'jigsaw';
import { GiveawayEntriesGraph } from './GiveawayEntriesGraph';
import { Text } from 'ui_2';
import { Network } from '@puzzlehq/sdk';

type GiveawayEntriesGraphModalProps = {
  selectedGiveaway: RaffleV2 & GiveawayStatus;
  network: Network;
  handleCloseModal: () => void;
};

export const GiveawayEntriesGraphModal = ({
  selectedGiveaway,
  network,
  handleCloseModal,
}: GiveawayEntriesGraphModalProps) => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4'>
      <div className='max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-lg bg-white p-6'>
        <div className='mb-4 flex items-center justify-between'>
          <div>
            <Text font='bold-lg'>{selectedGiveaway.title}</Text>
            <Text font='medium-sm' color='gray-600'>
              Participation Graph
            </Text>
          </div>
          <button
            onClick={handleCloseModal}
            className='rounded-full p-2 text-gray-500 hover:bg-gray-100'
          >
            <svg
              className='h-6 w-6'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M6 18L18 6M6 6l12 12'
              />
            </svg>
          </button>
        </div>

        {selectedGiveaway.programId && selectedGiveaway.giveawayId && (
          <GiveawayEntriesGraph
            programId={selectedGiveaway.programId}
            giveawayId={selectedGiveaway.giveawayId}
            network={network}
            height={400}
          />
        )}
      </div>
    </div>
  );
};
